import { Controller } from "@hotwired/stimulus";
import SlimSelect from "slim-select";

export default class extends Controller {
  static values = {
    placeholder: String,
  };

  connect() {
    const isMultiple = this.element.hasAttribute("multiple");

    // Determine placeholder from SimpleForm, fallback to defaults
    const defaultPlaceholder = isMultiple
      ? "Select multiple options..."
      : "Select an option...";
    const placeholderText = this.hasPlaceholderValue
      ? this.placeholderValue
      : defaultPlaceholder;

    this.select = new SlimSelect({
      select: this.element,
      settings: {
        placeholderText: placeholderText,
        searchPlaceholder: "Search...",
        allowDeselect: true,
        hideSelected: false,
      },
    });
  }

  disconnect() {
    if (this.select) {
      this.select.destroy();
    }
  }
}
